// services/profile.service.ts
import apiClient from '../api/api';
import { API_ENDPOINTS } from '../api/api.config';
import axios from 'axios';

export interface UserProfile {
  id: string;
  email: string;
  given_name: string;
  family_name: string;
  mobile_number?: string;
  status: string;
  groups: Array<{
    group_key: string;
    group_name: string;
    roles: string[];
  }>;
  profile_image?: string;
  employee_id?: string;
  full_name?: string;
}

export interface MeApiResponse {
  user: UserProfile;
  permissions: string[];
  tenant_key: string;
  last_login: string;
  registration_type: string;
}

export interface UpdateProfileRequest {
  user_id?: string;
  given_name?: string;
  family_name?: string;
  email?: string;
  mobile_no?: string;
  profile_image?: string;
}

export interface FileUploadResponse {
  success: boolean;
  code: number;
  data: {
    name: string;
    key: string;
    url: string;
    fileType: string;
  };
}

class ProfileService {
  /**
   * Get current user's profile from API
   */
  // async getMyProfile(): Promise<MeApiResponse> {
  //   try {
  //     const response = await apiClient.get(API_ENDPOINTS.USERS.MY_PROFILE);
  //     return response.data.data; // Assuming API returns {success, code, data: MeApiResponse}
  //   } catch (error) {
  //     console.error("Error fetching profile:", error);
  //     throw error;
  //   }
  // }

  /**
   * Update current user's profile
   */
  // async updateMyProfile(updateData: UpdateProfileRequest): Promise<MeApiResponse> {
  //   try {
  //     const response = await apiClient.put(API_ENDPOINTS.USERS.MY_PROFILE_UPDATE, updateData);
  //     return response.data.data; // Assuming API returns {success, code, data: MeApiResponse}
  //   } catch (error) {
  //     console.error("Error updating profile:", error);
  //     throw error;
  //   }
  // }

  /**
   * Upload profile picture
   */
  // async uploadProfilePicture(file: File): Promise<string> {
  //   try {
  //     const formData = new FormData();
  //     formData.append('file', file);

  //     const response = await apiClient.post(API_ENDPOINTS.USERS.UPLOAD_PROFILE_PICTURE, formData, {
  //       headers: { 'Content-Type': 'multipart/form-data' },
  //     });

  //     return response.data.data.url; // Assuming API returns {success, code, data: {url: string}}
  //   } catch (error) {
  //     console.error("Error uploading profile picture:", error);
  //     throw error;
  //   }
  // }

  /**
   * Update profile picture URL
   */
  // async updateProfilePicture(profileImageUrl: string): Promise<MeApiResponse> {
  //   return this.updateMyProfile({ profile_image: profileImageUrl });
  // }

  /**
   * Upload file for profile image
   */
  async uploadProfileImage(file: File): Promise<string> {
    try {
      const formData = new FormData();
      formData.append('file', file);

      const token = localStorage.getItem('auth_token');

      const response = await axios.put<FileUploadResponse>(
        `${import.meta.env.VITE_DMS_API}/dms-v2-srv/storage-srv/utils/upload?file=null`,
        formData,
        {
          headers: {
            'accept': '*/*',
            'Authorization': token ? `Bearer ${token}` : '',
            'Content-Type': 'multipart/form-data',
          },
        }
      );

      if (response.data.success) {
        return response.data.data.url;
      } else {
        throw new Error('Failed to upload file');
      }
    } catch (error: any) {
      console.error('Error uploading profile image:', error);
      throw new Error(error.response?.data?.message || 'Failed to upload profile image');
    }
  }

  /**
   * Update another user's profile by ID
   */
  async updateProfile(id: string, roleData: UpdateProfileRequest): Promise<UserProfile> {
    try {
      const response = await apiClient.put(
        API_ENDPOINTS.USERS.USER_PROFILE_UPDATE + `/${id}`,
        roleData
      );
      return response.data.data; // Assuming API returns {success, code, data: UserProfile}
    } catch (error) {
      console.error(`Error updating profile ${id}:`, error);
      throw error;
    }
  }

  /**
   * Email validation
   */
  validateEmail(email: string): boolean {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailRegex.test(email);
  }

  /**
   * Mobile number validation
   */
  validateMobileNumber(mobile: string): boolean {
    const mobileRegex = /^[\+]?[1-9][\d]{0,15}$/;
    return mobileRegex.test(mobile.replace(/[\s\-\(\)]/g, ""));
  }
}

export const profileService = new ProfileService();
